import {useGetHomepageDataQuery} from '@/redux/api';
import MainWrapper from "@/components/base/MainWrapper";
import Link from "next/link";
import styled from "styled-components";
import {getColor} from "@/styles/ThemeConfig";
import Head from "next/head";
import ForceSSRLink from "@/components/other/ForceSSRLink";

// Styled Components
const Container = styled.div`
  text-align: center;
  padding: 200px 0;
`;

const Title = styled.h1`
  font-size: 4em;
  text-transform: uppercase;
  font-family: 'Josefin Sans',sans-serif;
  margin-bottom: 1rem;
  color: rgb(73, 73, 73);

  span {
    color: rgb(148, 148, 148);
    font-size: 0.8em;
  }
`;

const Message = styled.p`
  font-family:  'Josefin Sans',sans-serif;
  font-size: 1.5em;
  color: rgb(73, 73, 73);

  a {
  font-family:  'Josefin Sans',sans-serif;
      font-size: 1.2em;
    color: ${getColor('gold')};
    text-decoration: none;
  }
`;

const FourOhFour = () => {
    const { data, error, isLoading } = useGetHomepageDataQuery();

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return <>
        <Head>
            <title>404</title>
            <meta name="description" content={'Sorry wrong page'}/>
            <meta property="og:title" content={'404'}/>
            <meta property="og:description" content={'Sorry wrong page'}/>
            <meta property="og:image" content={'https://web.secrettours.com/images/meta_default_poster.jpg'}/>
            <meta name="twitter:title" content={'404'}/>
            <meta name="twitter:description" content={'Sorry wrong page'}/>
            <meta name="twitter:image" content={'https://web.secrettours.com/images/meta_default_poster.jpg'}/>
            <meta name="twitter:card" content="summary_large_image"/>
        </Head>
        <MainWrapper
            regionsData={data?.data?.regions}
            headerData={data?.data?.header}
            footerData={data?.data?.footer}
            socialLinks={data?.data?.socialLinks}
            searchOptions={data?.data?.searchOptions}
        >
            <Container>
                <Title>
                    Sorry wrong page
                    <br/>
                    <span>Error 404</span>
                </Title>
                <Message>
                    <ForceSSRLink href="/">Click here</ForceSSRLink> to go to our homepage for more information.
                </Message>
            </Container>
        </MainWrapper>
    </>
};

export default FourOhFour;
